define([
	"dojo/_base/declare",
	"csi/action/Controller"
], function(declare,Controller) {

	return declare(Controller, {
		getFormData: function() {
			var	data = this.inherited(arguments);
			data.m_bSelectOne = true;
			data.m_bRequireOne = true;
			return data;
		}
	});
});